module.exports = __webpack_public_path__ + "static/img/sm.3b1c9fb5.svg";